import React, { useState } from 'react';

function Navbar() {
    const [activeLink, setActiveLink] = useState('in')

    return (
        <div className="bg-nav">
            <div className="left-link">
                <div className="link-title">
                    <a className={"link-a" + (activeLink === 'in' ? " active" : "")} href="#intro" onClick={() => setActiveLink('in')}>Intro</a>
                    <a className={"link-a" + (activeLink === 'sk' ? " active" : "")} href="#skill" onClick={() => setActiveLink('sk')}>Skills</a>
                    <a className={"link-a" + (activeLink === 'ex' ? " active" : "")} href="#experience" onClick={() => setActiveLink('ex')}>Experiences</a>
                    <a className={"link-a" + (activeLink === 'pr' ? " active" : "")} href="#project" onClick={() => setActiveLink('pr')}>Projects</a>
                    <a className={"link-a" + (activeLink === 'co' ? " active" : "")} href="#contact" onClick={() => setActiveLink('co')}>Contact</a>
                </div>
                <div className="hamburger-menu">
                    =
                </div>
            </div>
        </div>
    )
}

export default Navbar
